module.exports = __webpack_public_path__ + "media/images/steps_inactive_left_flat-e8b11f1cd68582e40bfe6cd212dcf7d4.png";